
    // IMPORTS
    import { computed, defineComponent, PropType } from 'vue'
    import { useBrowserStateStore } from '@/store/browserState';

    export default defineComponent({
        name: 'dynamicViewSwitcher',

        props: {
            threshold: { type: Number as PropType<number>, required: false, default: () => 500 },
        },

        setup(props) {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const browserState = useBrowserStateStore()

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const isLargeScreen = computed(() => (browserState.resolution?.width ?? 10000) >= props.threshold )
            const computedData = { isLargeScreen }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...computedData }
        }
    });
